module.exports = __webpack_public_path__ + "static/media/algo.80e0f600.svg";